export default __webpack_public_path__ + "f7ee675a09a98ed4478fd804cd5b47be.wav";